import { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import { HRM1040_R01FamilyDto } from './Dto_HRM1040_R01';

/** 가족과 학력 중 마지막으로 작업한 그리드이다. 액션바 등록·삭제·Excel의 대상 그리드를 정할 때 쓴다. */
export type HRM1040_R01GridType = 'family' | 'education';

/** 공통코드명이 없으면 원래 코드값을 표시한다. */
export const formatHRM1040_R01Code = (list: SysCodeDto[], value: string): string =>
    list.find(item => item.minorCd === value)?.codeNm || value;

/**
 * 삭제 표시를 제외한 공제가족 수에 본인을 더하고 상한 11명을 적용한다.
 * 부양과 세액공제가 모두 Y인 가족만 공제대상으로 센다.
 * @param familyList 현재 편집 중인 가족 목록
 * @param deletedIds 삭제 표시한 가족의 valueIndex 문자열 목록
 * @returns 본인을 포함한 공제가족 수(1~11)
 */
export const getHRM1040_R01DeductFamilyCount = (familyList: HRM1040_R01FamilyDto[], deletedIds: string[]): number => {
    const eligibleCount = familyList.filter(row =>
        !deletedIds.includes(String(row.valueIndex))
        && row.supportYn === 'Y'
        && row.deductTaxYn === 'Y',
    ).length;

    return Math.min(11, 1 + eligibleCount);
};

/**
 * 미지정 날짜의 DB 기본값을 화면에서 빈칸으로 표시한다.
 * 학력 날짜는 비워 두면 1900-01-01로 저장되므로 이 값은 "날짜 없음"으로 본다.
 * @param value 서버 또는 그리드의 날짜 문자열
 * @returns 표시할 날짜 문자열. 값이 없거나 1900-01-01이면 빈 문자열
 */
export const formatHRM1040_R01Date = (value: string | null | undefined): string =>
    !value || value === '1900-01-01' ? '' : value;
